<ng-template #contentVisites let-modal class="modal-share p-3">
    <div class="modal-header container border-0 pt-3">

        <button type="button" class="btn-close btn-close-black me-1" aria-label="Close"
            (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body  p-0">

        <div class="p-3 text-center">
            <h4>LISTE DES VISITES
            </h4>
        </div>

        <div class="bar-bloc text-white">
            <div class="product-desc agenda-page main-bg p-3">
                <div class="title-description white-title">
                    <div class="inner">
                        <div class="title-description text-uppercase">

                            <h3 class="white">{{bien.niveau.code_text}} <span *ngIf="bien.property.size_generique">de
                                    {{bien.property.size_generique}} m²</span> à<br>
                                <span class="accent">{{bien.ville}}</span>
                            </h3>
                        </div>

                        <p class="clearfix big-title">

                            <span style="float:right" class="float-right price-title">{{bien?.property.price_formatted}}&nbsp;€
                            </span>
                        </p>

                        <p class="location-title italic-title"
                            *ngIf="bien?.property?.adresseBien && !bien?.property.adresseBien.codePostalF">
                            {{bien?.property.location ? bien?.property.location : bien?.location}}</p>


                        <div class="details clearfix">
                            <span class="badge-list-item outlined">
                                Ref : {{bien.property.reference}}
                            </span>
                            <svg width="48" height="48" viewBox="0 0 15 15" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.40446 3.85168H3.08008V6.17606" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.18199 11.9871H11.2158V9.95323" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.11391 11.9871H3.08008V9.95323" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M5.98555 9.37213L3.08008 11.9871" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.18199 3.85168H11.2158V5.88552" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8.31035 6.46661L11.2158 3.85169" stroke="#ffffff" stroke-width="0.8"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span> {{bien.property.size_generique}} m²</span>

                            <span *ngIf="bien.property.pieces"> <svg width="48" height="48" viewBox="0 0 15 15"
                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.01309 6.46665V4.14227H1.20215V12.2776H12.2429V4.14227H9.62802"
                                        stroke="#ffffff" stroke-width="0.8" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M4.68848 12.2776L4.68848 7.91937" stroke="#ffffff" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12.2429 8.2099H8.46582" stroke="#ffffff" stroke-width="0.8"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                {{bien?.property.pieces ? bien?.property.pieces : bien?.pieces}} Pièce(s)
                            </span>
                            <span *ngIf="(bien?.property.room ? bien?.property.room : bien?.room)">
                                <svg width="48" height="48" viewBox="0 0 25 25" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M19.1635 18.388L17.8085 16.2649H4.63487L3.40301 18.3373C3.29432 18.5185 3.01172 18.446 3.01172 18.2286V10.9679C3.01172 10.7651 3.17838 10.5984 3.38127 10.5984H19.178C19.3809 10.5984 19.5475 10.7651 19.5475 10.9679V18.2793C19.5475 18.4895 19.2722 18.5692 19.1635 18.3953V18.388Z"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                    <path
                                        d="M3.91016 10.5984V5.46811L4.06957 5.42463C8.80134 4.24351 13.7505 4.25075 18.475 5.44637L18.562 5.46811V10.5984"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                    <path
                                        d="M12.5186 10.5984V9.69263C12.5186 8.48976 13.4968 8.10571 14.6997 8.10571C15.9025 8.10571 16.8808 8.48976 16.8808 9.69263V10.5984"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                    <path
                                        d="M5.52539 10.5984V9.69263C5.52539 8.48976 6.49638 8.10571 7.69925 8.10571C8.90212 8.10571 9.88035 8.48976 9.88035 9.69263V10.5984"
                                        stroke="#ffffff" stroke-width="0.8" stroke-miterlimit="10" />
                                </svg>
                                {{bien?.property.room ? bien?.property.room : bien?.room}}
                                Chambre{{(bien?.property.room ? bien?.property.room : bien?.room) > 1 ? 's' : ''}}
                            </span>
                        </div>
                    </div>
                </div>
                <!-- formulaire liste -->
                <div class="listevisites-bloc">
                    <div class="content mesInfos-content list-wrapper">
                        <p class="text-visites">Vous retrouverez dans la liste ci-dessous les visites passées et à venir
                            pour ce bien.</p>
                    </div>
                </div>
                <!-- /formulaire liste -->
            </div>
        </div>
        <div class="data-bloc-visites p-1 p-md-4">
            <div class="row">
                <!-- Rotating card -->
                <div *ngFor="let dataDetailEvent of VisitesData; let i = index;"
                    class="col-12 col-md-4 card border-0 flip-card my-2">
                    <div class="flip-card-inner">
                        <div class="flip-card-front p-3">
                            <div *ngIf="dataDetailEvent">
                                <h5 *ngIf="dataDetailEvent?.start">
                                    {{dataDetailEvent?.start | dateFormatter}}</h5>
                                <div class="applicant-bloc row">
                                    <div class="col-3">
                                        <div class="timeslot-interval">
                                            <p class="startTime m-0">
                                                {{dataDetailEvent?.start | hourFormatter}}
                                            </p>
                                            <i class="bi bi-chevron-bar-down fw-semibold"></i>

                                            <p class="endTime">
                                                {{dataDetailEvent?.end | hourFormatter}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="col-9">
                                        <div class="timeslot-desc">
                                            <p *ngIf="dataDetailEvent?.visit_detail?.isMyVisit == true
                                            || (dataDetailEvent?.data?.isOwner
                                            && !dataDetailEvent?.visit_detail?.urlCancelVisit)">
                                                Demandeur
                                                <span>{{dataDetailEvent?.visit_detail?.applicant}}</span>
                                            </p>
                                            <p *ngIf="dataDetailEvent?.visit_detail?.keysitter?.isProprio == false">
                                              Conseiller :
                                                <span>{{dataDetailEvent?.visit_detail?.keysitter?.name}}</span>
                                                <!-- a revoir ? {{checkLocalMarket(dataDetailEvent?.visit_detail) ?
                                                checkLocalMarket(dataDetailEvent?.visit_detail) : 'N/A'}} -->
                                            </p>
                                            <p *ngIf="dataDetailEvent?.visit_detail?.keysitter?.isProprio == true">
                                                Propriétaire :
                                                <span>{{dataDetailEvent?.visit_detail?.keysitter?.name}}</span>
                                            </p>
                                            <!-- User connecté Demandeur ou Propriétaire -->
                                            <p *ngIf="dataDetailEvent?.visit_detail?.urlCancelVisit
                                                    && (dataDetailEvent?.visit_detail?.isMyVisit == true || dataDetailEvent?.data?.isOwner )">
                                              <span>Annuler la visite</span>
                                            </p>
                                            <!-- User connecté Demandeur visite -->
                                            <p *ngIf="dataDetailEvent?.visit_detail?.isMyVisit == true
                                                && dataDetailEvent?.visit_detail?.keysitter?.report?.length === 0
                                                && !dataDetailEvent?.visit_detail?.urlCancelVisit">
                                                <span>Rédiger votre compte-rendu</span>
                                            </p>
                                            <!-- date de visite dépassée réponse enregistrée Visite acceptée (visite refusée non affichée) -->
                                            <!-- User connecté Demandeur visite -->
                                            <p *ngIf="(dataDetailEvent?.visit_detail?.keysitter?.report?.status || dataDetailEvent?.visit_detail?.keysitter?.report?.comment)
                                                && dataDetailEvent?.visit_detail?.isMyVisit == true">
                                                <span>Compte-rendu transmis</span>
                                            </p>
                                            <!-- User connecté Propriétaire -->
                                            <p *ngIf="(dataDetailEvent?.visit_detail?.keysitter?.report?.status || dataDetailEvent?.visit_detail?.keysitter?.report?.comment)
                                                && dataDetailEvent?.data?.isOwner">
                                                <span>Voir le Compte-Rendu</span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flip-card-back p-3">
                            <!-- User connecté Demandeur visite -->
                            <span *ngIf="dataDetailEvent?.visit_detail?.isMyVisit == true">
                                <p *ngIf="dataDetailEvent?.visit_detail?.urlCancelVisit">
                                    Vous pouvez annuler la visite en cliquant sur le bouton suivant<br>
                                  <app-modal-delete-visite  [visiteId]="dataDetailEvent?.id"></app-modal-delete-visite>
                                </p>
                                <!-- Compte rendu non fait -->
                                <!-- todo: Cyrille VERIFIER ne pas afficher le texte avant heure de visite ni après date de visite + 30 Jours -->
                                <span *ngIf="!dataDetailEvent?.visit_detail?.urlCancelVisit && dataDetailEvent?.visit_detail?.keysitter?.report?.length === 0">
                                    Vous pouvez réaliser le compte rendu en cliquant sur le bouton suivant
                                    <div class="text-white">
                                        <app-modal-evaluation [bien]="bien"
                                                              [visite]="dataDetailEvent">
                                        </app-modal-evaluation>
                                    </div>
                                </span>
                                <!-- Compte rendu fait -->
                                <span
                                    *ngIf="(dataDetailEvent?.visit_detail?.keysitter?.report?.status || dataDetailEvent?.visit_detail?.keysitter?.report?.comment)">
                                    Le compte-rendu a été transmis au Conseiller THE DOOR MAN en charge du bien que vous
                                    venez de visiter, qui en fera part à son client vendeur.
                                    <div class="text-white">
                                        <app-modal-evaluation [bien]="bien" [readOnly]="true"
                                            [visite]="dataDetailEvent"></app-modal-evaluation>
                                    </div>
                                </span>
                            </span>
                            <!-- User connecté Vendeur -->
                            <span *ngIf="dataDetailEvent?.data?.isOwner">
                                <p *ngIf="dataDetailEvent?.visit_detail?.urlCancelVisit">
                                    Vous pouvez annuler la visite en cliquant sur le bouton suivant<br>
                                  <app-modal-delete-visite  [visiteId]="dataDetailEvent?.id"></app-modal-delete-visite>
                                </p>
                                <!-- Compte rendu non fait -->
                                <span *ngIf="!dataDetailEvent?.visit_detail?.urlCancelVisit && !dataDetailEvent?.visit_detail?.keysitter?.report?.status">
                                    Le compte-rendu n'a pas été renseigné sur l'application
                                </span>
                                <!-- Compte rendu fait -->
                                <span *ngIf="dataDetailEvent?.visit_detail?.keysitter?.report?.status">
                                    Vous pouvez consulter votre compte rendu en cliquant sur le bouton suivant
                                    <div class="text-white">
                                        <app-modal-evaluation [bien]="bien" [readOnly]="true"
                                            [visite]="dataDetailEvent"></app-modal-evaluation>
                                    </div>
                                </span>
                            </span>
                            <!-- User connecté Ni demandeur visite Ni Vendeur -->
                            <span
                                *ngIf="dataDetailEvent?.visit_detail?.isMyVisit != true && !dataDetailEvent?.data?.isOwner">
                                Un autre client acquéreur<br>a visité ce bien
                            </span>
<!--                          <p>{{dataDetailEvent?.visit_detail?.isMyVisit}}</p>-->
<!--                          <p>{{dataDetailEvent?.visit_detail?.isMyBien}}</p>-->
                        </div>
                    </div>
                </div>
                <!-- Rotating card -->
            </div>
            <p *ngIf="!VisitesData?.length && isLoadedHttp" class="no-offers text-center">Aucune visite enregistrée.</p>
        </div>
    </div>
</ng-template>
<div class="btn-bien">
  <a role="button" class="iconClass w-100" (click)="openVertically(contentVisites)"
     [attr.aria-label]="'Voir les visites du bien (' + nbVisites + ')'">
  <span class="badge badge-secondary text-bleu-tdm" aria-hidden="true">{{nbVisites}}</span>
  <i class="w-100 bi bi-eye" aria-hidden="true"></i>
</a>
</div>
<app-modal-alert-bien *ngIf="showAlert" [status]="statusConfirmation"
    [message]="messageConfirmation"></app-modal-alert-bien>
